// extracted by mini-css-extract-plugin
export var aircallIframe = "_mj-3";
export var fabContainer = "_mj-5";
export var fabRinging = "_mj-6";
export var loadingOverlay = "_mj-4";
export var pulse = "_mj-7";
export var widgetContent = "_mj-2";
export var widgetPanel = "_mj-0";
export var widgetPanelExpanded = "_mj-1";